RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const RadioButton = views.RadioButton = Marionette.View.extend({
        events: {
            'change': function () {

                const me = this;
                me.model.set({
                    selected: me.$el.is(':checked')
                });
            }
        },
        modelEvents: {
            'change:selected': 'render'
        },
        tagName: 'input',
        attributes: function () {

            const me = this;
            const optional = {};

            const name = me.getOption('name');

            if (name) {

                _.extend(optional, {
                    name: name
                });
            }

            return _.extend({
                type: 'radio',
                checked: Boolean(me.model.get('selected'))
            }, optional);
        },
        render: function () {

            const me = this;
            const attributes = _.result(me, 'attributes');
            me.$el.attr(attributes);
        }
    });

    /**
     * Gets item view options from a configuration.
     * @param {Object} config The configuration.
     * @returns {Object} An object representing view options.
     */
    RadioButton.getItemViewOptionsFromConfig = function (config) {

        return _.pick(config, 'name', 'model');
    };

});
